import { ContactFormIcon } from 'src/icons/navigation-icons/contact-form-icon';
import { EmployeesIcon } from 'src/icons/navigation-icons/employees-icon';
import { MobileAppManagementIcon } from 'src/icons/navigation-icons/mobile-app-management';
import { OrganizationDetailsIcon } from 'src/icons/navigation-icons/organization-details-icon';
import { PasswordIcon } from 'src/icons/navigation-icons/password-icon';
import { RouteTitle, SidebarRouteTitle } from 'src/types/enum/route-title';
import { RoutesGroup } from 'src/types/interfaces/routes-group';
import { EventsIcon } from '../../icons/navigation-icons/events-icon';
import { MessagesIcon } from '../../icons/navigation-icons/messages-icon';
import { PostsIcon } from '../../icons/navigation-icons/posts-icon';
import { PinIcon } from 'src/icons/navigation-icons/pin-icon';
import { SurveysIcon } from 'src/icons/navigation-icons/surveys-icon';
import { PartnershipsIcon } from 'src/icons/navigation-icons/partnerships-icon';
import { GuestsIcon } from 'src/icons/navigation-icons/guests-icon';
import { BookingsIcon } from 'src/icons/navigation-icons/bookings-icon';
import { IssuesIcon } from 'src/icons/navigation-icons/issues-icon';
import { BulbIcon } from 'src/icons/bulb';

export const getRoutes = (): RoutesGroup[] => [
  {
    title: SidebarRouteTitle.BUILDING_MANAGEMENT,
    routes: [
      {
        icon: EmployeesIcon,
        title: RouteTitle.PROPERTY_MEMBERS,
        href: '/property-members',
        id: 'property_members_navigation_link',
      },
      {
        icon: PinIcon,
        title: RouteTitle.AMENITIES,
        href: '/amenities',
        id: 'amenities_navigation_link',
      },
      {
        icon: MobileAppManagementIcon,
        title: RouteTitle.MOBILE_APP_DISPLAY,
        href: '/mobile-app-display/home-screen',
        id: 'mobile_app_display_navigation_link',
      },
      {
        icon: BulbIcon,
        title: RouteTitle.FAQS,
        href: '/faqs',
        id: 'faqs_navigation_link',
      },
    ],
  },
  {
    title: SidebarRouteTitle.APP_CONTENT,
    routes: [
      {
        icon: MessagesIcon,
        title: RouteTitle.PUSH_NOTIFICATIONS,
        href: '/push-notifications',
        id: 'publications_push_notifications_navigation_link',
      },
      {
        icon: PostsIcon,
        title: RouteTitle.NEWS,
        href: '/news',
        id: 'publications_news_navigation_link',
      },
      {
        icon: EventsIcon,
        title: RouteTitle.EVENTS,
        href: '/events',
        id: 'publications_events_navigation_link',
      },
      {
        icon: PinIcon,
        title: RouteTitle.PLACES,
        href: '/places',
        id: 'publications_places_navigation_link',
      },
      {
        icon: SurveysIcon,
        title: RouteTitle.SURVEYS,
        href: '/surveys',
        id: 'publications_surveys_navigation_link',
      },
      {
        icon: PartnershipsIcon,
        title: RouteTitle.PARTNERSHIPS,
        href: '/partnerships',
        id: 'publications_partnerships_navigation_link',
      },
    ],
  },
  {
    title: SidebarRouteTitle.DATA_AND_ISSUES,
    routes: [
      {
        icon: GuestsIcon,
        title: RouteTitle.GUESTS,
        href: '/guests',
        id: 'guests_navigation_link',
      },
      {
        icon: BookingsIcon,
        title: RouteTitle.BOOKINGS,
        href: '/bookings',
        id: 'bookings_navigation_link',
      },
      {
        icon: IssuesIcon,
        title: RouteTitle.ISSUES,
        href: '/issues',
        id: 'issues_navigation_link',
      },
    ],
  },
  {
    title: SidebarRouteTitle.SUPPORT_AND_SETTINGS,
    routes: [
      {
        icon: OrganizationDetailsIcon,
        title: RouteTitle.ADMINS_AND_CONCIERGES,
        href: '/administrators',
        id: 'management_navigation_link',
      },
      {
        icon: PasswordIcon,
        title: RouteTitle.PASSWORD,
        href: '/password',
        id: 'password_navigation_link',
      },

      {
        icon: ContactFormIcon,
        title: RouteTitle.CONTACT_FORM,
        href: '/contact-form',
        id: 'contact_form_navigation_link',
      },
    ],
  },
];
